__turbopack_context__.v({
  "container": "CoreNav-module-scss-module__iNbo7W__container",
  "coreNav": "CoreNav-module-scss-module__iNbo7W__coreNav",
  "label": "CoreNav-module-scss-module__iNbo7W__label",
  "select": "CoreNav-module-scss-module__iNbo7W__select",
  "selectIcon": "CoreNav-module-scss-module__iNbo7W__selectIcon",
  "selectWrapper": "CoreNav-module-scss-module__iNbo7W__selectWrapper",
});
